import { useEffect, useState } from 'react'
import mammoth from 'mammoth'

interface DocxViewerProps {
  blobUrl: string
}

const DocxViewer: React.FC<DocxViewerProps> = ({ blobUrl }) => {
  const [docContent, setDocContent] = useState<string>('')

  useEffect(() => {
    const fetchAndRenderDocx = async () => {
      try {
        const response = await fetch(blobUrl)
        const blob = await response.blob()
        const arrayBuffer = await blob.arrayBuffer()
        const result = await mammoth.extractRawText({ arrayBuffer })
        setDocContent(result.value)
      } catch (error) {
        setDocContent('Unable to display the document.')
      }
    }

    fetchAndRenderDocx()
  }, [blobUrl])

  return (
    <div>
      <div
        style={{
          border: '1px solid #ccc',
          padding: '16px',
          borderRadius: '8px',
          whiteSpace: 'pre-wrap',
        }}
        dangerouslySetInnerHTML={{ __html: docContent }}
      />
    </div>
  )
}

export default DocxViewer
